import { useEffect, useRef } from 'react';

// Handoff landing page for the admin "View Portal" button. The button opens this
// route in a new tab with the minted portal tokens in the URL hash. We stash
// them in this tab's sessionStorage (marked 'pv' so the auth layer reads from
// sessionStorage here, isolated from the admin's localStorage), strip the hash,
// then full-reload into the portal so AuthContext boots fresh as that user.
export function PortalViewBootstrap() {
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const params = new URLSearchParams(window.location.hash.slice(1));
    const at = params.get('at');
    const rt = params.get('rt');
    const role = params.get('role');

    if (!at || !rt) {
      window.location.replace('/portal/login');
      return;
    }

    try {
      sessionStorage.setItem('pv', '1');
      sessionStorage.setItem('accessToken', at);
      sessionStorage.setItem('refreshToken', rt);
    } catch {
      // sessionStorage unavailable — nothing we can do; bail to login.
      window.location.replace('/portal/login');
      return;
    }

    const dest = role === 'client' ? '/portal/client' : '/portal/employee';
    // Full navigation (not SPA) so AuthContext re-initialises from sessionStorage.
    window.location.replace(dest);
  }, []);

  return (
    <div className="flex h-screen items-center justify-center text-gray-500 text-sm">
      <span className="material-symbols-outlined animate-spin mr-2">progress_activity</span>
      Opening portal…
    </div>
  );
}
